<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 25"
        fill="none"
        width="24"
        height="25">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9993 24.8325C18.6263 24.8325 23.9985 19.4603 23.9985 12.8333C23.9985 6.20624 18.6263 0.833984 11.9993 0.833984C5.37225 0.833984 0 6.20624 0 12.8333C0 19.4603 5.37225 24.8325 11.9993 24.8325ZM12.699 7.10257H13.9105V20.4969H16.625V5.00764H12.6766C8.70578 5.00764 6.6194 7.03579 6.6194 10.0221C6.6194 12.4068 7.76356 13.8108 9.80505 15.2595L6.26049 20.4969H9.19938L13.1477 14.6355L11.7793 13.7217C10.1191 12.6074 9.31153 11.7382 9.31153 9.86609C9.31153 8.21696 10.4781 7.10257 12.699 7.10257Z"
            fill="currentColor" />
    </svg>
</template>

<script setup lang="ts"></script>
